import { Box, Text } from '@chakra-ui/react';

import { PALETTE_COLORS } from '../../constants';

interface EmptyStateProps {
  searchLength: number;
}

function EmptyState({ searchLength }: EmptyStateProps) {
  return (
    <Box p="32px" textAlign="center">
      <Text color={PALETTE_COLORS.textMuted}>
        {searchLength >= 3 ? 'No results found' : 'No commands found'}
      </Text>
    </Box>
  );
}

export default EmptyState;
